import { createSlice } from '@reduxjs/toolkit';
import toggleSelectedItem from './helper/toggleSelectedItem';
import { SelectedItemAction, SelectedItemsAction, bikerState } from './type';

const initialState: bikerState = {
  selectedItem: [],
  selectedBikerId: '',
};

const batchBikersSlice = createSlice({
  name: 'batchBikers',
  initialState,
  reducers: {
    setOrdersSelectedItems: (state, action: SelectedItemsAction) => ({
      ...state,
      selectedItem: action?.payload?.selectedItems,
    }),
    setOrdersSelectedItem: (state, action: SelectedItemAction) => ({
      ...state,
      selectedItem: [...state.selectedItem, action?.payload?.selectedItem],
    }),
    toggleOrdersSelectedItem: (state, action: SelectedItemAction) =>
      toggleSelectedItem(state, action.payload.selectedItem),
  },
});

export default batchBikersSlice;
